<script type="text/babel">
    export default{
        data () {
            return {
                gdprTermsAccepted: (this.$cookie.get('gpdr-terms-accepted')) ? true : false
            }
        },
        mounted () {
        },
        props: [],
        computed: {
        },
        methods: {
            closeBanner () {
                this.$cookie.set('gpdr-terms-accepted', true, 3650)
                this.gdprTermsAccepted = true
            }
        }
    }
</script>
